<template>
	<div>
		<div class="header-background">
			<el-carousel
				v-if="swiperList.length > 0"
				:height="carouselHeight + 'px'"
			>
				<el-carousel-item
					v-for="item in swiperList"
					:key="item.id"
					class="swiper-item"
					:style="{ backgroundImage: `url(${item.picPath})` }"
				>
				</el-carousel-item>
			</el-carousel>
			<img
				v-else
				src="https://oss.cuttlefish.vip/file/backstageManagement/serveManage/1625643239478.png"
				alt=""
			/>
		</div>

		<div class="intro-images">
			<img
				class="intro-image"
				src="https://oss.cuttlefish.vip/file/h5upload/178177551524162494314.png"
				alt="公司简介"
				draggable="false"
			/>
			<img
				class="intro-image"
				src="https://oss.cuttlefish.vip/file/h5upload/178177551874684382513.png"
				alt="IP介绍"
				draggable="false"
			/>
			<img
				class="intro-image"
				src="https://oss.cuttlefish.vip/file/h5upload/178177552314177361879.png"
				alt="历程"
				draggable="false"
			/>
		</div>
	</div>
</template>

<script>
	import { articleList } from "@/http/api";
	export default {
		data() {
			return {
				swiperList: [],
				carouselHeight: 720,
			};
		},
		created() {
			this.getSwiperList();
		},
		methods: {
			async getSwiperList() {
				const { data } = await articleList({ nid: "os_home_swiper" });

				if (data.code === 200) {
					data.data.articles.forEach((item) => {
						item.picPath = this.$oss + item.picPath;
					});
					this.swiperList = data.data.articles;
					this.imgLoad();
				}
			},
			// 获取图片的实际长度和宽度
			getImgAttr(url, callback) {
				let img = new Image();
				img.src = url;
				if (img.complete) {
					callback(img.width, img.height);
				} else {
					img.onload = function () {
						callback(img.width, img.height);
						img.onload = null;
					};
				}
			},
			imgLoad() {
				this.$nextTick(function () {
					if (this.swiperList.length) {
						this.getImgAttr(this.swiperList[0].picPath, (width, height) => {
							let screenWidth =
								window.innerWidth ||
								document.documentElement.clientWidth ||
								document.body.clientWidth;
							this.carouselHeight = (height / width) * screenWidth;
						});
					}
				});
			},
		},
	};
</script>

<style scoped lang="scss">
	.header-background {
		.el-carousel {
			width: 100%;
			height: 100%;
			.swiper-item {
				width: 100%;
				height: 100%;
				background-size: 100% 100%;
			}
		}
	}
	.intro-images {
		display: flex;
		flex-direction: column;
		align-items: center;
		box-sizing: border-box;
		width: 100%;
		padding: 48px 24px 24px;
		.intro-image {
			display: block;
			width: 86%;
			max-width: 1200px;
			height: auto;
			margin-bottom: 56px;
			pointer-events: none;
			user-select: none;
			-webkit-user-drag: none;
			&:last-child {
				margin-bottom: 0;
			}
		}
	}
</style>
